import RockefellerNonContextApiSlice from '../../api/RockefellerNonContextApiSlice'
import { Logger } from '../../system/appinsights/Logger'
import { fetchDynamicConfigUrl, InvalidateTotpSessionURL, SendUserActivityUrl } from '../Constants'
import { DynamicConfigResponse, UserActivityLog } from './types'

export const SharedApiSlice = RockefellerNonContextApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchDynamicConfig: builder.query<DynamicConfigResponse, string | undefined | null | void>({
      queryFn: async (_args, _api, _extraOptions, baseQuery) => {
        const url = _args ? `${fetchDynamicConfigUrl}?configtype=${_args}` : `${fetchDynamicConfigUrl}`
        const response = await baseQuery({ url: url, method: 'GET' })
        if (response.error) {
          Logger.LogException({
            message: `FetchDynamicConfig::${JSON.stringify(response.error.data ?? '')}`,
            exceptionType: 'API_ERROR'
          })
          return { error: { status: 500, data: undefined } }
        }
        const data = response.data as DynamicConfigResponse
        if (data) {
          return { data: data }
        } else {
          return { error: { status: 500, data: undefined } }
        }
      },
      providesTags: ['Refresh']
    }),
    invalidateTotp: builder.mutation<void, void>({
      queryFn: async (_args, _api, _extraOptions, baseQuery) => {
        const url = `${InvalidateTotpSessionURL}`
        const response = await baseQuery({ url: url, method: 'GET' })
        if (response.error) {
          Logger.LogException({
            message: `AppSignOut::${JSON.stringify(response.error.data ?? '')}`,
            exceptionType: 'API_ERROR'
          })
          return { error: { status: 500, data: undefined } }
        }
        return { data: undefined }
      }
    }),
    sendUserActivity: builder.mutation<void, UserActivityLog[]>({
      queryFn: async (_args, _api, _extraOptions, baseQuery) => {
        const url = `${SendUserActivityUrl}`
        const response = await baseQuery({ url: url, method: 'POST', body: _args })
        if (response.error) {
          Logger.LogException({
            message: `SendUserActivity Failed::${JSON.stringify(response.error.data ?? '')}`,
            exceptionType: 'API_ERROR'
          })
          return { error: { status: 500, data: undefined } }
        }
        return { data: undefined }
      }
    })
  })
})
export const {
  useFetchDynamicConfigQuery,
  useLazyFetchDynamicConfigQuery,
  useInvalidateTotpMutation,
  useSendUserActivityMutation
} = SharedApiSlice
